import { styled, Popover } from '@mui/material';

import { Button } from 'theSource/components';

export const ButtonStyled = styled(Button)({
  margin: 15,
  padding: '5px 75px',
});

export const PopoverStyled = styled(Popover)(({ theme }) => ({
  marginTop: 20,
  [theme.breakpoints.down('lg')]: {
    display: 'none',
  },
}));

export const ProfilePictureImgStyled = styled('img')({
  width: '55%',
  borderRadius: '50%',
  cursor: 'pointer',
});

export const AvatarProfilePictureImgStyled = styled('button')({
  backgroundColor: '#ffff',
});
